import { Modal, ModalDialog, ModalClose, Typography, Box, Button, Textarea } from '@mui/joy';

const fmtMoney = (v) => Number(v || 0).toLocaleString('ru-RU', { maximumFractionDigits: 0 });

/**
 * Модалка причины отмены чека. Показывается тем, у кого cancel_mode = 'request'
 * (админы, рабочие аккаунты) — им отмена доступна только через согласование.
 * Логики нет: собирает причину и отдаёт наверх. Управляется хуком useOrderCancel.
 */
export default function CancelOrderModal({
    open, order, total, reason, saving, onReasonChange, onSubmit, onClose,
}) {
    const amount = total ?? order?.value;

    return (
        <Modal open={open} onClose={() => !saving && onClose()}>
            <ModalDialog sx={{
                bgcolor: 'var(--joy-palette-background-level1)',
                border: '1px solid var(--joy-palette-divider)',
                borderRadius: 'var(--joy-radius-xl)',
                maxWidth: 420, width: '100%', p: { xs: 2, sm: 3 },
            }}>
                <ModalClose disabled={saving} />

                <Typography sx={{ fontSize: 17, fontWeight: 800, mb: 0.5 }}>
                    Отменить чек
                </Typography>

                <Typography sx={{ fontSize: 12, color: 'var(--joy-palette-text-secondary)', mb: 1.5 }}>
                    {order && (
                        <Box component="span" sx={{ fontWeight: 700, color: 'var(--joy-palette-text-primary)' }}>
                            {fmtMoney(amount)} ₽
                            {order.photographer_name ? ` — ${order.photographer_name}` : ''}
                            {'. '}
                        </Box>
                    )}
                    Отмена требует согласования. Заявку рассмотрит руководитель — до его решения
                    чек остаётся активным и продолжает считаться в выручке.
                </Typography>

                <Typography sx={{
                    fontSize: 11, fontWeight: 700, textTransform: 'uppercase',
                    letterSpacing: '0.06em', color: 'var(--joy-palette-text-secondary)', mb: 0.4,
                }}>
                    Причина (обязательно)
                </Typography>
                <Textarea
                    minRows={2} maxRows={4}
                    placeholder="Например: клиент отказался от съёмки; ошиблись типом оплаты"
                    value={reason || ''}
                    onChange={(e) => onReasonChange(e.target.value.slice(0, 300))}
                    sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        color="warning"
                        onClick={onSubmit}
                        loading={saving}
                        disabled={(reason || '').trim().length < 3}
                        sx={{ flex: 1, fontWeight: 800 }}
                    >
                        Отправить заявку
                    </Button>
                    <Button
                        variant="outlined" onClick={onClose} disabled={saving}
                        sx={{ borderColor: 'var(--joy-palette-divider)', color: 'var(--joy-palette-text-secondary)' }}
                    >
                        Отмена
                    </Button>
                </Box>
            </ModalDialog>
        </Modal>
    );
}